import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
import {
  generateRandomString,
  formatPhoneNumber,
} from "../../../utils/helpers";
import InputStyles from "../InputStyles";

const phoneRegex = /((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}/;

// handles formatting on change
const PhoneInput = ({
  label = "Phone",
  register,
  formState: { errors = {} } = {},
  fieldName,
  placeholder = "555-555-5555",
  required,
  setValue,
  helperText,
  errorMessage,
  showPhoneSignPosting,
}) => {
  const handleChange = (e) => {
    const value = e.target.value;
    const formatted = formatPhoneNumber(value);
    setValue(fieldName, formatted, {
      shouldValidate: formatted?.length === 14,
    });
  };

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const inputRandomId = isClient
    ? `${fieldName}-${generateRandomString()}`
    : null;

  return (
    <>
      <InputStyles className="phone-input">
        <div className="label-container">
          <div>
            <label
              htmlFor={inputRandomId}
              dangerouslySetInnerHTML={{ __html: label }}
            />
            {required && <span className="required-asterisk">*</span>}
          </div>
          {helperText && <span className="helper-text">{helperText}</span>}
        </div>
        <input
          type="tel"
          id={inputRandomId}
          className={`${errors[fieldName] ? "error" : ""}`}
          {...register(fieldName, {
            required: required ? errorMessage || `${label} is required` : false,
            pattern: {
              value: phoneRegex,
              message: "Phone number is not valid",
            },
          })}
          placeholder={placeholder}
          onChange={(e) => handleChange(e)}
        />
        {errors[fieldName] && (
          <span className="input-error">{errors[fieldName].message}</span>
        )}
      </InputStyles>
    </>
  );
};
export default PhoneInput;

// PhoneInput.propTypes = {
//   register: PropTypes.func.isRequired,
//   fieldName: PropTypes.string.isRequired,
//   label: PropTypes.string,
//   required: PropTypes.bool,
//   formState: PropTypes.object,
//   placeholder: PropTypes.string,
//   errorMessage: PropTypes.string,
//   setValue: PropTypes.func.isRequired,
//   helperText: PropTypes.string,
//   showPhoneSignPosting: PropTypes.bool,
// };
